import { useState } from "react";
import { useNavigate } from "react-router-dom";

const heroBg =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20illustration%20of%20a%20moody%20moonlit%20night%20scene%20with%20floating%20glowing%20game%20controller%20icons%2C%20abstract%20stars%20and%20silhouetted%20figures%2C%20warm%20amber%20and%20deep%20crimson%20palette%20over%20cream%2C%20sophisticated%20magazine%20cover%20art%2C%20cinematic%20and%20elegant%2C%20no%20text&width=1600&height=900&seq=hero-home-001&orientation=landscape";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/ranking?q=${encodeURIComponent(q)}` : "/ranking");
  };

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroBg} alt="幻夜志首页插画" className="h-full w-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-center px-4 pb-24 pt-20 text-center md:px-6 md:pb-32 md:pt-28">
        <p className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/20 px-4 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur-sm">
          <i className="ri-fire-line text-primary-300"></i>
          2026 成人游戏口碑推荐站 · 神作与入门全收录
        </p>
        <h1 className="mt-7 max-w-3xl font-display text-3xl font-black leading-snug text-background-50 md:text-5xl md:leading-tight">
          想玩优质作品又怕踩雷？
          <br />
          <span className="text-primary-300">幻夜志</span> 帮你锁定下一款心头好
        </h1>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
          这里收录工口游戏推荐、排行榜、专业评测与神作盘点，按口碑与类型整理。
          从入门首选到十年神作，每一部都经过编辑实机验证，让你不再大海捞针。
        </p>

        <form
          onSubmit={submit}
          className="mt-9 flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center sm:rounded-full sm:bg-background-50/95 sm:p-1.5 sm:shadow-none"
        >
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索作品、类型或关键词，如：神作、纯爱、悬疑"
              className="w-full rounded-full bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 sm:bg-transparent sm:py-2.5"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600 sm:py-2.5"
          >
            <i className="ri-search-2-line"></i>
            开始寻找
          </button>
        </form>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-center">
          {[
            { num: "128+", label: "实机评测" },
            { num: "8 类", label: "主题分类" },
            { num: "12 部", label: "年度神作" },
            { num: "30w+", label: "社区口碑" },
          ].map((s) => (
            <div key={s.label}>
              <div className="font-display text-2xl font-black text-primary-300">{s.num}</div>
              <div className="mt-1 text-xs text-background-100/80">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}